<template>
    <div>
        <div class="d-flex align-items-center flex-wrap mt-3 mb-4">
            <div class="custom-control custom-radio custom-control-v2 mr-2 mb-2" v-for="(item, date) in items" :key="date">
                <input type="radio" :id="'date-' + date" v-model="data.date.key" :value="date" class="custom-control-input">
                <label class="custom-control-label d-flex align-items-center" :for="'date-' + date">
                    <img class="custom-control-icon" src="/img/calendar.svg" alt="" style="height: 14px;">
                    <span class="text-muted ml-2" v-html="item.display_date_from"></span>
                </label>
            </div>
        </div>

        <div v-if="data.date && filteredItems">
            <div class="card _shadow mb-4" v-for="(item, itemKey) in filteredItems.basic" :key="itemKey">
                <div class="card-body py-0">
                    <div class="row">
                        <div class="col-md-3 py-3 pl-3 pr-0" v-if="item.room.image">
                            <figure class="cover border m-0" style="height: 180px;" :style="'background-image: url(' + item.room.image.thumb + ')'"></figure>
                        </div>

                        <div class="col-md-6 py-3">
                            <h3 class="h4 font-weight-bold text-dark mt-0 mb-3" v-html="item.name"></h3>
                            <ul class="list-unstyled">
                                <li class="d-flex align-items-center" v-if="item.room.label"><img src="/img/suitcase.svg" alt="" class="mr-1" style="height: 14px;">{{ item.room.label }}</li>
                                <li class="d-flex align-items-center"><img src="/img/calendar.svg" alt="" class="mr-1" style="height: 14px;">{{ items[data.date.key].display_date_from + ' - ' + items[data.date.key].display_date_to }}</li>
                                <li class="d-flex align-items-center" v-if="item.room.map"><img src="/img/bed.svg" alt="" class="mr-1" style="height: 14px;"><a :href="item.room.map.md" data-fancybox>Shema/tlocrt kabine</a></li>
                                <li class="d-flex align-items-center" v-if="item.room.virtualView">
                                    <a :href="item.room.virtualView" target="_blank">360 panorama</a>
                                </li>
                            </ul>
                        </div>

                        <div class="col-md-3 d-flex flex-column align-items-end py-3 ml-auto">
                            <h4 class="h5 text-primary mb-0">
                                <span v-if="
                                    item.price.label == 'first_minute' ||
                                    item.price.label == 'last_minute' ||
                                    item.price.label == 'special'
                                "
                                      class="d-block text-muted font-weight-bold"
                                      style="font-size: .875em;">
                                    <del v-html="$priceFormat(getRegularPrice(item))"></del>
                                </span>
                                <span class="text-primary font-weight-bold" v-html="$priceFormat(item.price.amount)"></span>
                            </h4>
                            <span>po osobi</span>

                            <select class="custom-select custom-select-sm mt-auto" style="width: auto;" @change="setData(itemKey, $event)">
                                <option value="0" selected>0</option>
                                <option :value="n" v-for="n in 3" :key="n" v-html="n"></option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <table class="table mb-0" v-if="! _.isEmpty(data.items) && _.has(data.items, itemKey)">
                            <tbody>
                                <tr v-for="(d, i) in data.items[itemKey]" :key="i">
                                    <td colspan="3" class="px-3">
                                        <div class="form-inline">
                                            <span class="font-weight-bold" v-html="'Kabina ' + (parseInt(i) + 1)"></span>
                                            <label class="ml-5 mr-2">Odrasli:</label>
                                            <select class="form-control form-control-sm" v-model="d.adults">
                                                <option :value="n" v-for="n in avblAdults(itemKey, i)" :key="n" v-html="n"></option>
                                            </select>
                                            <template v-if="item.data.minAge && item.data.maxAge && avblChildren(itemKey, i) > 0">
                                                <label class="ml-3 mr-2">Djeca:</label>
                                                <select class="form-control form-control-sm" v-model="d.children">
                                                    <option value="0">0</option>
                                                    <option :value="n" v-for="n in avblChildren(itemKey, i)" :key="n" v-html="n"></option>
                                                </select>
                                            </template>
                                            <template v-if="d.children > 0">
                                                <label class="ml-3 mr-2">Godine djece:</label>
                                                <select class="form-control form-control-sm mr-1" v-model="d.childrensAge[n-1]" v-for="n in d.children" :key="n">
                                                    <option :value="y" v-for="y in $range(item.data.minAge, item.data.maxAge)" :key="y" v-html="y"></option>
                                                </select>
                                            </template>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row border-top" v-if="data.date && filteredItems.required">
                        <div class="col-12 py-3">
                            <h4 class="h6 font-weight-bold text-uppercase m-0">Obavezne doplate</h4>
                            <small class="text-muted">Obavezne doplate se računaju po pojedinoj osobi.</small>

                            <ul class="list-unstyled mt-2 mb-0">
                                <li class="d-flex align-items-end" v-for="(_item, _itemKey) in filteredItems.required" :key="_itemKey">
                                    <span v-html="_item.name"></span>
                                    <span class="text-primary font-weight-bold ml-auto" v-html="$priceFormat(_item.price.amount)"></span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="row border-top" v-if="data.date && filteredItems.optional">
                        <div class="col-12 py-3">
                            <h4 class="h6 font-weight-bold text-uppercase m-0">Neobavezne doplate</h4>
                            <small class="text-muted">Neobavezne doplate se odabiru prilikom kreiranja upita i naplate.</small>

                            <ul class="list-unstyled mt-2 mb-0">
                                <li class="d-flex align-items-end" v-for="(_item, _itemKey) in filteredItems.optional" :key="_itemKey">
                                    <span v-html="_item.name"></span>
                                    <span class="text-primary font-weight-bold ml-auto" v-html="$priceFormat(_item.price.amount)"></span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="row border-top" v-if="item.room.description">
                        <div class="col-12 py-3">
                            <h6 class="text-dark font-weight-bold">Opis kabine:</h6>
                            <ul class="list-default _aligned mb-0">
                                <li v-html="descriptionItem" v-for="(descriptionItem, i) in item.room.description.split('\r\n')" :key="i"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="stick-to-bot d-flex align-items-end justify-content-lg-end" v-if="isValidated">
            <button type="button" class="btn btn-primary btn-lg" :disabled="! isValidated" @click="submit($event)">Pošalji upit</button>
        </div>
    </div>
</template>

<script>
export default {
    components: {},

    props: {
        item: {
            type: Object,
            required: true
        },
        items: {
            type: Object,
            required: true
        },
        requiredItems: {
            type: Object,
            required: true
        },
        optionalItems: {
            type: Object,
            required: true
        },
        firstDateFrom: {
            type: String,
            required: true
        },
        firstDateTo: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            data: {},
            cart: {}
        }
    },

    computed: {
        filteredItems: function () {
            if (this.data.date) {
                let key = this.data.date.key

                return {
                    basic: this.items[key] ? this.items[key].items : null,
                    required: this.requiredItems[key] ? this.requiredItems[key].items : null,
                    optional: this.optionalItems[key] ? this.optionalItems[key].items : null
                }
            }
        },

        avblAdults: function () {
            return function (key, index) {
                let item = this.filteredItems.basic[key],
                    capacity = item && item.capacity ? parseInt(item.capacity) : 0,
                    selectedItem = this.data.items[key][index]

                return capacity - parseInt(selectedItem.children)
            }
        },

        avblChildren: function () {
            return function (key, index) {
                let item = this.filteredItems.basic[key],
                    capacity = item ? item.capacity : 0,
                    selectedItem = this.data.items[key][index]

                return capacity - parseInt(selectedItem.adults)
            }
        },

        isValidated: function () {
            if (this.data.date && ! _.isEmpty(this.data.items)) {
                return true
            }

            return false
        }
    },

    beforeMount() {
        Vue.set(this.data, 'slug', this.item.slug)
        Vue.set(this.data, 'type', 'cruise')
        Vue.set(this.data, 'items', {})
        Vue.set(this.data, 'date', {
            key: this.firstDateFrom + '|' + this.firstDateTo,
        })
    },

    watch: {
        "data.items": {
            handler: function () {},
            deep: true
        },

        "data.date": {
            handler: function () {
                if (! _.isEmpty(this.data.items)) {
                    this.data.items = {}
                    document.querySelector('table select').value = 0
                }
            },
            deep: true
        }
    },

    methods: {
        setData(key, e) {
            let n = e.srcElement.value,
                item = this.filteredItems.basic[key]

            if (n > 0 && item) {
                let selectedItems = _.isEmpty(this.data.items) || _.isEmpty(this.data.items[key]) ? [] : this.data.items[key]

                if (selectedItems.length == 0) {
                    this.$set(this.data.items, key, [])
                } else if (n < selectedItems.length) {
                    for (let i = 1; i <= n; i ++) {
                        this.data.items[key].splice(-1, 1)
                    }
                }

                for (let i = 1; i <= n - selectedItems.length; i ++) {
                    this.data.items[key].push({
                        adults: 1,
                        children: 0,
                        childrensAge: []
                    })
                }
            } else {
                this.$delete(this.data.items, key)
            }
        },

        getRegularPrice(item) {
            let value2

            $.each(item.options, function(key, value) {
                if (value.type == 'regular') {
                    value2 = value.amount
                }
            });

            return value2
        },

        validateChildren() {
            let items = this.data.items,
                validated = true

            _.forEach(items, function (item) {
                _.forEach(item, function (data) {
                    if (data.children > 0 && data.childrensAge.length != data.children) {
                        validated = false
                    }
                })
            })

            return validated
        },

        validatePersons() {
            let $this = this,
                items = this.data.items,
                validated = true

            _.forEach(items, function (item, key) {
                _.forEach(item, function (data) {
                    let qty = $this.filteredItems.basic[key].capacity,
                        total = parseInt(data.adults) + parseInt(data.children)

                    if (qty > 2) {
                        if (total < 2) {
                            validated = false
                        }
                    } else if (total < qty) {
                        validated = false
                    }
                })
            })

            return validated
        },

        submit(e) {
            let btn = e.target

            if (! this.validateChildren()) {
                alert('Odaberite godine djeteta.')
                return false
            }

            if (! this.validatePersons()) {
                alert('Nije popunjen kapacitet sobe.')
                return false
            }

            btn.disabled = true

            axios.post('/naplata', this.data)
                .then(function (response) {
                    if (response.data.status == 'success') {
                        window.location.href = '/naplata'
                    } else {
                        btn.disabled = false
                    }
                })
                .catch(function (error) {
                    btn.disabled = false
                })
        }
    }
}
</script>
